import { addClassName } from 'utilities';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import {
  CashFlowSummaryCellMap, CashFlowSummaryParserParams, CashFlowSummaryRowData, EvaluatedCashFlowSummaryCell,
} from './types';

const NA_LABEL = 'N/A';

export const CashFlowSummaryParser = (
  params: CashFlowSummaryParserParams
): CashFlowSummaryCellMap => {
  const { rowConfig, columns } = params;

  const alphabet = alphabetGenerator([], columns.length);
  const cells: CashFlowSummaryCellMap = {};

  rowConfig.forEach((rowItem, rowIndex) => {
    const rowNumber = rowIndex + 1;
    const irrRowData = rowItem as CashFlowSummaryRowData;

    columns.forEach((col, colIndex) => {
      const columnLegend = alphabet[colIndex];
      const cellKey = `${columnLegend}${rowNumber}`;

      if (rowIndex === 0) {
        cells[cellKey] = {
          ...col,
          value: col.value,
          key: cellKey,
          alias: col.alias,
          columnLegend,
          rowNumber,
          expr: col.value,
        } as EvaluatedCashFlowSummaryCell;
        return;
      }

      let value: string | number | null = null;

      switch (col.alias) {
        case 'fund_name':
          value = irrRowData.name;
          break;
        case 'investments':
          value = irrRowData.investments;
          break;
        case 'proceeds':
          value = irrRowData.proceeds;
          break;
        case 'total':
          value = irrRowData.total;
          break;
        case 'gross_irr':
          value = irrRowData.grossIrr === null ? NA_LABEL : irrRowData.grossIrr;
          break;
        default:
          value = null;
      }

      const baseClassName = col.className ?? '';
      const className = irrRowData.isTotal
        ? addClassName(baseClassName, 'gross-irr-total-row').trim()
        : baseClassName;

      const isNaCell = col.alias === 'gross_irr' && irrRowData.grossIrr === null;

      cells[cellKey] = {
        ...col,
        value,
        entityId: irrRowData.id,
        key: cellKey,
        alias: col.alias,
        columnLegend,
        rowNumber,
        readOnly: true,
        expr: value?.toString() ?? '',
        className,
        format: isNaCell ? undefined : col.format,
      };
    });
  });

  return cells;
};
